"use strict";

/** 
* Базовый объект страницы.
*
* @class WebAccess.components.wrappers.BasePageElement
* @extends BaseObject
* @property {string} className Имя класса
* @property {string} name Имя объекта
* @property {string} selector Селектор для работы с объектом вне API
*/

(function (global) {
  var BasePageElement = BaseObject.extend({

    /**
    * Конструктор
    * @param {string} itemSelector Селектор существующего элемента страницы
    * @method WebAccess.components.wrappers.BasePageElement#init
    */
    init: function (itemSelector) {
      this._super(itemSelector);
      this._jObject = $(itemSelector);
      this.name = this._jObject.attr("name");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: "BasePageElement",
    name: "",
    selector: "",

    /** @private */
    _jObject: {},
    /** @private */
    _storedEvents: [],
    /** @private */
    _byNameSelectorTemplate: "{0}[name='{1}']",
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Признак скрытия объекта.
    * 
    * @method WebAccess.components.wrappers.BasePageElement#isHidden
    * @return {boolean} True, если объект скрыт, иначе False.
    */
    isHidden: function () {
      return !this._jObject.is(":visible");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
      * Признак отображения объекта.
      * 
      * @method WebAccess.components.wrappers.BasePageElement#isEnabled
      * @return {boolean} True, если объект отображается, иначе False.
      */
    isEnabled: function () {
      return !this._jObject.hasClass("disabled");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
      * Признак выбора объекта.
      * 
      * @method WebAccess.components.wrappers.BasePageElement#isSelected
      * @return {boolean} True, если объект выбран, иначе False.
      * @since 5.0.0.4203
      */
    isSelected: function () {
      return this._jObject.hasClass("selected");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отобразить скрытый объект.
     * 
     * @method WebAccess.components.wrappers.BasePageElement#show
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
    */
    show: function () {
      this._jObject.show();
      this.fire("show");
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть объект.
    * 
    * @method WebAccess.components.wrappers.BasePageElement#hide
    * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
    */
    hide: function () {
      this._jObject.hide();
      this.fire("hide");
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Добавить подпись к объекту.
    * 
    * @param {string} text Текст подписи
    * @method WebAccess.components.wrappers.BasePageElement#setLabel
    * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.        
    */
    setLabel: function (text) {
      this._jObject.find("span").text(text);
      this.fire("change");
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить текст подписи объекта.
    * 
    * @method WebAccess.components.wrappers.BasePageElement#getLabel
    * @return {string} Текст подписи объекта.
    */
    getLabel: function () {
      return this._jObject.find("span").text();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Установить всплывающую подсказку.
    * 
    * @param {string} text Текст всплывающей подсказки
    * @method WebAccess.components.wrappers.BasePageElement#setTooltip
    * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement. 
    * @since 5.0.0.4005
    */
    setTooltip: function (text) {
      var me = this;
      var label = me.getLabel();
      var tooltip = text;
      // Добавим название кнопки в подсказку к этой кнопке.
      if (tooltip !== label) {
        tooltip = label + '\n' + tooltip;
      }
      me._jObject.attr('title', tooltip);
      me.fire("change");
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить текст всплывающей подсказки.
    * 
    * @method WebAccess.components.wrappers.BasePageElement#getTooltip
    * @return {string} Текст всплывающей подсказки.
    * @since 5.0.0.4005
    */
    getTooltip: function () {
      return this._jObject.attr("title");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установить иконку.
     *
     * Иконку необходимо разместить в папке проекта App_Sprites и после скопилировать проект.
     * 
     * @example 
     * WebAccess.current.sideBar.tabs.create("FilterRRCAssignment1")
     *          .enable().setLabel(L("RRC_ASSIGNMENTS_FILTER"))
     *          .setIcon("SidebarAndExtensions/EDocumentSearch_24.png") 
     *           
     * WebAccess.current.sideBar.tabs.create("FilterRRCAssignment1")
     *          .enable()
     *          .setLabel(L("RRC_ASSIGNMENTS_FILTER"))
     *          .setIcon("/App_Sprites/SidebarAndExtensions/EDocumentSearch_24.png") 
     * 
     * @param {string} path Путь к иконке
     * @method WebAccess.components.wrappers.BasePageElement#setIcon
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
    */
    setIcon: function (path) {

      if (path.indexOf(".") !== -1) {

        var jSvgIcon = this._jObject.find("svg");

        if (jSvgIcon.length != 0) {
          jSvgIcon.remove();
          var jContainer = this._jObject.find("div").first();
          jContainer.prepend("<p></p>");
        }

        if (path.indexOf("/App_Sprites/") !== -1) {
          path = path.substring(path.indexOf("s/") + 2);
        };

        this._jObject.find("p").first().removeClass().addClass(path);
      }
      else {
        var jSpriteIcon = this._jObject.find("p").first();
        if (jSpriteIcon.length !== 0) {
          var jContainer = this._jObject.find("div").first();
          jSpriteIcon.remove();
          jContainer.prepend('<svg class="svg-component"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + path + '"></use></svg>');
        }
        else {
          var jUseElement = this._jObject.find("use").first();
          jUseElement.attr("xlink:href", "#" + path);
        }
      }

      this.fire("change");
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить имя иконки.
     *    
     * @method WebAccess.components.wrappers.BasePageElement#getIcon
     * @return {string} Имя иконки.
    */
    getIcon: function () {

      var jSvgIcon = this._jObject.find("svg");

      if (jSvgIcon.length !== 0)
        return jSvgIcon.children("use").attr("xlink:href").substr(1);

      return this._jObject.find("p").first().attr('class');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Имитировать щелчок мыши.
     * Имитация щелчка мыши на кнопке либо установка обработчика на событие onClick, если передан callback. 
     * Заменяет обработчик, установленный по умолчанию. Используется в прикладной разработке.
     * 
     * @param {function} [opt_callback] Функция, которая будет вызвана после щелчка мыши по кнопке
     * @method WebAccess.components.wrappers.BasePageElement#click
     * @throws ERR_OBJECT_IS_ALREADY_RENDERED – объект уже отображен.
     * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
     *
     * @example
     * WebAccess.current.toolBar.buttons.CrtRefRecords.click();
     * WebAccess.current.toolBar.buttons.CrtRefRecords.click(function() {
     *  alert("Существующие обработчки событий click были перезаписаны данным");
     * })
     */
    click: function (opt_callback) {
      var instance = this;
      if ($.isFunction(opt_callback)) {
        this._disableClickHandler(this._jObject);
        this.unbind('click').bind("click", opt_callback);
      } else {
        this._jObject.click();
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _defaultAction: function () {
      if (!this._inlineEvent) return;
      return (new Function(this._inlineEvent)).call(this._jObject.get(0));
    },

    /**
    * Выхов нашего fire при клике на элемент
    * @private
    */
    _eventHandler: function (event) {
      var eventName = event.data.eventName;
      var name = event.data.buttonName;
      var element = event.data.instance;
      var continueDefaultAction = event.data.continueDefaultAction;

      if (element.fire(eventName, name, continueDefaultAction) !== false && eventName === 'click') {
        element._defaultAction.call(element);
      };
    },

    /** 
    * Привязать функцию к событию. 
    * Аналогичен методу click, но без замены обработчиков.
    *
    * @example
    * var tab = WebAccess.current.sideBar.tabs.create("FilterRRCAssignment1");
    *     tab.bind("click",function () { createFilterTabs("RRCAssignments"); });
    * @method WebAccess.components.wrappers.BasePageElement#bind
    * @param {string} name Имя события
    * @param {function} callback Функция, срабатывающая при событии
    * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BaseObject.
    */
    bind: function (event, callback) {
      var instance = this;
      if (event === 'click') this._storeInlineEvents();

      this._super(event, callback);
      //if (event == "click") this._disableClickHandler(this._jObject);    
      this._jObject.unbind(event, this._eventHanler).bind(event, {
        "instance": instance,
        "eventName": event,
        "buttonName": instance.name,
        "continueDefaultAction": $.proxy(instance._defaultAction, instance)
      }, this._eventHandler);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Отключение обработчика click у объекта
    * @method WebAccess.components.wrappers.BasePageElement#_disableClickHandler
    * @private
    */
    _disableClickHandler: function (jObject) {

      jObject.removeAttr("onclick"); // Здесь именно так 
      jObject.prop("onclick", null); // именно две строки

      jObject.off("click");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сделать кнопку недоступной. 
    * Кнопка становится полупрозрачной и не реагирует на события.
    * 
    * @method WebAccess.components.wrappers.BasePageElement#disable
    * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
    */
    disable: function () {
      if (this.isEnabled()) { // Без этого если вызывать disable 2 раза, то он потеряет собятия вообще.
        this._storeEvents();
        this._jObject.unbind("click");
        this._jObject.addClass("disabled").removeClass('hover');
        this.fire("disable");
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сделать кнопку доступной.
    * 
    * @method WebAccess.components.wrappers.BasePageElement#enable
    * @return {WebAccess.components.wrappers.BasePageElement} Объект типа BasePageElement.
    */
    enable: function () {
      if (!this.isEnabled()) {
        this._jObject.removeClass("disabled");
        this._restoreEvents();
        this.fire("enable");
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сохранение привязанных обработчиков событий
    * 
    * @private 
    * @method WebAccess.components.wrappers.BasePageElement#_storeEvents
    * @return {WebAccess.components.wrappers.BasePageElement}
    */
    _storeEvents: function () {
      this._storeInlineEvents();
      this._storedEvents = this._events;

      this._events = [];
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сохранение того, что было навешено на атрибут onclick.
    * @private 
    * @method WebAccess.components.wrappers.BasePageElement#_storeInlineEvents
    */
    _storeInlineEvents: function () {
      if (this._jObject.hasAttr("onclick")) {
        if (WA.ENV.browser.name !== 'IE' && WA.ENV.browser.major !== '7') {
          this._inlineEvent = this._jObject.attr("onclick"); //Здесь имеенно attr, не prop! и точка.
          this._jObject.removeAttr("onclick"); // Аналогично
        }
        //this._jObject.prop("onclick")
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Восстановление привязанных обработчиков событий
    * 
    * @private
    * @method WebAccess.components.wrappers.BasePageElement#_storeEvents
    * @return {WebAccess.components.wrappers.BasePageElement}
    */
    _restoreEvents: function () {
      this._restoreInlineEvents();
      if (Object.keys(this._storedEvents).length > 0) {
        this._events = this._storedEvents;
        this._storedEvents = [];

        var instance = this;
        for (var event in this._events) {
          if (this._events.hasOwnProperty(event)) {
            this._jObject.bind(event, function () {
              instance.fire(event, instance.name);
            });
          }
        }
      }

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Восстановление привязанных атрибутом обработчиков событий onclick
    * 
    * @private
    * @method WebAccess.components.wrappers.BasePageElement#_restoreInlineEvents
    */
    _restoreInlineEvents: function () {
      if (this._inlineEvent !== "") {
        this._jObject.attr("onclick", this._inlineEvent);
      }; //И здесь имеенно attr, не prop! железно!
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  global.BasePageElement = BasePageElement;

})(window.WebAccess.components.wrappers);
